import { render, staticRenderFns } from "./DigitalImage.vue?vue&type=template&id=cc918416&scoped=true&"
import script from "./DigitalImage.js?vue&type=script&lang=js&"
export * from "./DigitalImage.js?vue&type=script&lang=js&"
import style0 from "./DigitalImage.scss?vue&type=style&index=0&id=cc918416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc918416",
  null
  
)

export default component.exports